export default "__VITE_ASSET__9ba0b32b__"